import React, { Component } from 'react';
import PropTypes from 'prop-types';

import config from 'config';
import Helmet from 'react-helmet';
import Button from 'react-bootstrap/lib/Button';
import Col from 'react-bootstrap/lib/Col';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';
import ExplainerVideoModal from 'components/LandingPage/ExplainerVideoModal/ExplainerVideoModal';
import HeaderWithBackgroundPattern from 'components/HeaderWithBackgroundPattern/HeaderWithBackgroundPattern';
import LandingGetStarted from 'components/LandingPage/LandingGetStarted/LandingGetStarted';
import LandingHowItWorks from 'components/LandingPage/LandingHowItWorks/LandingHowItWorks';
import LandingWhyUseTwine from 'components/LandingPage/LandingWhyUseTwine/LandingWhyUseTwine';
import LandingPressSection from 'components/LandingPage/LandingPressSection/LandingPressSection';
import SvgIcon from 'components/SvgIcon/SvgIcon';
import styles from './WhyUseTwine.module.scss';

export default class WhyUseTwine extends Component {
  static propTypes = {
    stats: PropTypes.object,
    // functions
    loadStats: PropTypes.func,
  };

  constructor() {
    super();

    this.state = {
      showExplainer: false,
    };
  }

  componentDidMount() {
    if (!this.props.stats.loadingStats && !this.props.stats.loadedStats) {
      this.props.loadStats();
    }
  }

  render() {
    const { showExplainer } = this.state;

    const usersCount = (
      Math.round(this.props.stats.count / 10000) * 10000
    ).toLocaleString('en-US', { minimumFractionDigits: 0 });

    return (
      <div>
        <Helmet
          description="8 reasons why Twine is the perfect platform to hire freelancers that will grow your business"
          link={[{ rel: 'canonical', href: config.baseUrl + '/whyusetwine' }]}
          meta={[
            {
              name: 'description',
              content:
                '8 reasons why Twine is the perfect platform to hire freelancers that will grow your business',
            },
            { property: 'og:title', content: 'Why use Twine' },
            {
              property: 'og:description',
              content:
                '8 reasons why Twine is the perfect platform to hire freelancers that will grow your business',
            },
            { property: 'og:url', content: config.baseUrl + '/whyusetwine' },
            { name: 'twitter:title', content: 'Why use Twine' },
            {
              name: 'twitter:description',
              content:
                '8 reasons why Twine is the perfect platform to hire freelancers that will grow your business',
            },
          ]}
          title="Why use Twine"
        />
        <HeaderWithBackgroundPattern className={styles.header}>
          <h1>Matching You With The Best Quality Freelancers</h1>
          <Grid fluid>
            <Row>
              <Col xs={12} sm={6}>
                <Button
                  bsStyle="success"
                  href="/post-a-job"
                  className={styles.getStartedButton}
                >
                  Get started
                </Button>
              </Col>
              <Col xs={12} sm={6}>
                <Button
                  bsStyle="success"
                  onClick={() => this.setState({ showExplainer: true })}
                  className={styles.howItWorksButton}
                >
                  How it works{' '}
                  <SvgIcon
                    icon="play_circle"
                    size="16"
                    style={{ marginLeft: '5px' }}
                  />
                </Button>
              </Col>
            </Row>
          </Grid>
        </HeaderWithBackgroundPattern>
        <LandingWhyUseTwine
          usersCount={usersCount}
          title=""
          style={{ paddingBottom: '50px' }}
        />
        <LandingHowItWorks gradient style={{ paddingBottom: '50px' }} />
        <LandingGetStarted
          title="See what our creatives can do"
          linkText="Browse the categories"
          link="/hire-a-freelancer"
          gradient
          className={styles.getStarted}
        />
        <LandingPressSection />
        <ExplainerVideoModal
          show={showExplainer}
          onExit={() => this.setState({ showExplainer: false })}
        />
      </div>
    );
  }
}
